module.exports = __webpack_public_path__ + "static/media/starindas.17587321.png";